module.exports = __webpack_public_path__ + "img/PPMP33.c5ce48a6.png";